import styled from 'styled-components';

// div styled buttons
const CommonDivButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${({ width }) => width};
  padding: ${({ padding }) => padding || '0 25px'};
  cursor: ${({ cursor }) => cursor || `pointer`};
  border-radius: ${({ borderRadius, theme }) =>
    borderRadius || theme.button.borderRadius};
  margin: ${({ margin }) => margin};
`;
export const SecondaryButton = styled(CommonDivButton)`
  min-height: ${({ height, theme }) => height || theme.button.secondary.height};

  background-color: ${({ bgColor, theme }) =>
    bgColor || theme.button.secondary.bgColor};
  color: ${({ textColor, theme }) =>
    textColor || theme.button.secondary.textColor};
  font-size: ${({ fontSize, theme }) => fontSize || theme.button.fontSize};
  font-weight: ${({ fontWeight, theme }) =>
    fontWeight || theme.button.secondary.fontWeight};
  border: 1px solid
    ${({ borderColor, theme }) =>
      borderColor || theme.button.secondary.borderColor};

  &:hover {
    background-color: ${({ hoverBgColor, theme }) =>
      hoverBgColor || theme.button.secondary.hoverBgColor};
    border-color: ${({ hoverBgColor, theme }) =>
      hoverBgColor || theme.button.secondary.hoverBgColor};
    color: ${({ hoverTextColor, theme }) =>
      hoverTextColor || theme.button.secondary.hoverTextColor};
  }
`;

export const IconArrow = styled.img`
  margin: ${({ margin }) => margin || '0'};
  height: ${({ size }) => size};
  width: ${({ size }) => size};
  background-color: ${({ bgColor, theme }) =>
    bgColor || theme.button.secondary.bgColor};
  border: 1px solid
    ${({ borderColor, theme }) =>
      borderColor ? borderColor : theme.input.borderColor.default};
  border-radius: ${({ borderRadius }) => borderRadius || '6px'};
  padding: ${({ padding }) => padding || '0'};
  box-sizing: border-box;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};

  &:hover {
    border-color: ${({ theme, disabled }) =>
      disabled
        ? theme.input.borderColor.default
        : theme.dropdown.borderColor.hover};
    box-shadow: ${({ theme, disabled }) =>
      disabled ? 'none' : theme.dropdown.focusShadow};
  }
`;

export const FilterButton = styled(CommonDivButton)`
  padding: ${({ padding }) => padding || '0 25px'};
  margin: ${({ margin }) => margin || '0'};
  /* min-height: ${({ height, theme }) => height || theme.button.height}; */
  height: ${({ height }) => height || '40px'};
  font-size: ${({ fontSize, theme }) => fontSize || theme.button.fontSize};
  font-weight: ${({ fontWeight, theme }) =>
    fontWeight || theme.fontWeights.regular};
  background-color: ${({ bgColor, theme }) =>
    bgColor || theme.button.secondary.bgColor};
  border: 1px solid
    ${({ borderColor, theme }) =>
      borderColor ? borderColor : theme.input.borderColor.default};
  border-radius: ${({ borderRadius }) => borderRadius || '6px'};
  padding: ${({ padding }) => padding || '0'};
  box-sizing: border-box;
  cursor: pointer;

  &:hover {
    border-color: ${({ theme }) => theme.dropdown.borderColor.hover};
    box-shadow: ${({ theme }) => theme.dropdown.focusShadow};
  }
`;

export const ImageContainer = styled.div`
  background-color: ${({ isHovered }) => (isHovered ? 'black' : 'none')};
  height: 150px;
  width: 100%;
  border-radius: 8px;
`;

export const Image = styled.img`
  opacity: ${({ isHovered }) => (isHovered ? 0.5 : 1)};
  cursor: ${({ isHovered }) => (isHovered ? 'pointer' : 'default')};
  height: 150px;
  width: 100%;
  border-radius: 8px;
  transition: opacity 0.3s ease-in-out;
`;

export const MagnifyIcon = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  cursor: pointer;
`;
